import * as Yup from 'yup';

export const forgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string().email('Enter a valid email').required('This field is required'),
});
